export default {
  ISSATIFIED_NOT_IMPLEMENT: "The isSatisfied method of the object has not been redefined",
  AND_NOT_IMPLEMENT: "The and method of the object has not been redefined",
  OR_NOT_IMPLEMENT: "The or method of the object has not been redefined",
  NOT_NOT_IMPLEMENT: "The not method of the object has not been redefined",
}
